import { isNumber, isString } from "../utils/schemaUtils";
import { isLinearIssue, type LinearIssue } from "./linearIssuesSchema";

export interface LinearIssueDetail extends LinearIssue {
  type: "linear_issue";
  description?: string;
  createdAt: string;
  commentCount: number;
}

export const parseLinearIssuePayload = (v: unknown): LinearIssueDetail | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "linear_issue") return null;
  if (!isLinearIssue(r)) return null;
  if (r.description !== undefined && !isString(r.description)) return null;
  if (!isString(r.createdAt)) return null;
  if (!isNumber(r.commentCount)) return null;
  const issue: LinearIssue = r;
  return {
    ...issue,
    type: "linear_issue",
    description: r.description,
    createdAt: r.createdAt,
    commentCount: r.commentCount,
  };
};
